<app-menu-option-new
  [state]="state"
  [menuOption]="menuOption"
  (onSubMenuClick)="handleMenuClick($event)"
  >
</app-menu-option-new>
<div>
  <app-sub-menu [isMenuCollapsed]="state === 'collapsed'" [submenuOptions]="menuOption?.submenu?.subMenuList!"/>
</div>
